import { render, staticRenderFns } from "./DutyPartsSelectionResult.vue?vue&type=template&id=76a5dbe6&"
import script from "./DutyPartsSelectionResult.vue?vue&type=script&lang=js&"
export * from "./DutyPartsSelectionResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports